<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="480px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Approve JO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="JO No."
                      v-model="form.joNumber"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Nap Code*"
                      v-model="form.napCode"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Port*"
                      v-model="form.port"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click="closeDialog()">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import Snackbar from "../Snackbar.vue";
export default {
  name: "ApproveJoDialog",
  components: {
    Snackbar,
  },
  props: ["dialog", "data"],
  data() {
    return {
      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        napCode: "",
        port: "",
        joNumber: "",
      },
    };
  },
  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      this.$emit("response", this.form);
      this.$refs.form.reset();
      this.loadingBtn = false;
    },

    closeDialog() {
      this.$emit("response", false);
      this.$refs.form.reset();
    },

    formatDate(d, format = "YYYY-MM-DD HH:mm:ss") {
      return moment(d).format(format);
    },

    trimMobileNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    selectRole(e) {
      if (e === "Full access") {
        this.form.installer = false;
        this.form.ibasP2P = false;
      }

      if (e === "P2P") {
        this.form.installer = false;
        this.form.ibasP2P = true;
      }

      if (e === "Installer") {
        this.form.installer = true;
        this.form.ibasP2P = false;
      }
    },
  },

  created() {
    // this.getLocation();
  },

  watch: {
    dialog(val) {
      // console.log(Object.keys().length === 0);
      // this.$refs.form.reset();
      if (val && this.$props.data) {
        console.log(this.$props.data);
        setTimeout(() => {
          const currentData = this.$props.data;
          const form = this.form;
          form.joNumber = currentData.account.jo_no;
          Object.keys(form)
            .filter((key) => key in currentData)
            .forEach((key) => {
              form[key] = currentData[key];
            });
        }, 500);
      }
    },
  },
};
</script>
